import { Injectable } from "@angular/core";
import { File } from "@ionic-native/file";
import { FileChooser } from "@ionic-native/file-chooser";
import { IOSFilePicker } from "@ionic-native/file-picker";
import { ModalController } from "ionic-angular";
import { ModalStorageRequestPermissionPage } from "../../pages/general/modal-storage-request-permission/modal-storage-request-permission";
import { PermissionCheckProvider } from "../permission-check/permission-check";

/*
  Generated class for the FileChooserProvider provider.
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class FileChooserProvider {

  constructor(
    public fileChooser: FileChooser,
    public permissionCheckProvider: PermissionCheckProvider,
    private modalCtrl: ModalController,
    private filePicker: IOSFilePicker,
    private file: File
  ) { }

  async open() {
    let result = '';

    try {
      const url = await this.fileChooser.open();
      result = `file://${url}`;
    } catch (error) {
      throw error;
    }

    return result
  }

  pickFileIOS() {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const filePath = await this.filePicker.pickFile();
        const originalName = filePath.substring(filePath.lastIndexOf('/') + 1);
        const path = 'file://' + filePath.substring(0, filePath.lastIndexOf('/') + 1);
        const fileType = originalName.substring(originalName.lastIndexOf('.'));
        const newPath = this.file.cacheDirectory;
        const newName = new Date().getTime() + fileType;
        const fileEntry = await this.file.copyFile(path, originalName, newPath, newName);
        const url = fileEntry.nativeURL.substring(7);
        resolve(url);
      } catch (error) {
        reject(error);
      }
    })
  }

  modalPermissionAllFiles() {
    const modal = this.modalCtrl.create(ModalStorageRequestPermissionPage);
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/file-chooser/file-chooser.ts